import React from 'react';
import { Box, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { ForgotPasswordForm } from './components';
import { ResetPasswordFooter } from './components/reset-password-footer.component';

export const ResetPasswordPage = () => {
  const l10n = useL10n();

  return (
    <>
      <Box pt={7} />
      <Typography sx={{ mb: 4 }} variant="h2" align="center">{l10n.auth.forgotPassword}</Typography>
      <ForgotPasswordForm />
      <ResetPasswordFooter />
    </>
  );
};
